import dynaForms from '@elab/core/utils/dynaForms';

const getSelectors = storeName => {
    const getGiftCard = state => state[storeName] || {};
    const getCardInfo = state => getGiftCard(state).cardInfo || {};
    const getGiftCards = state => getGiftCard(state).giftCards || [];
    const getIsPayment = state => getGiftCard(state).isPayment || false;
    const getIsVoucher = state => getGiftCard(state).isVoucher || false;
    const getCouponValidation = state => getGiftCard(state).isCouponValidationEnabled || false;
    const getValidationPattern = state => getGiftCard(state).couponValidationPattern || '';
    const getCouponErrorText = state => getGiftCard(state).couponErrorText || '';
    const getIsBalanceCheck = state => getGiftCard(state).isBalanceCheck || false;
    const getScrollToError = state => getGiftCard(state).scrollToError || false;
    const getErrors = state => getGiftCard(state).errors || {};
    const getGiftCardData = state => getGiftCard(state).data || {};
    const getGiftCardNumber = state => getGiftCardData(state).giftCardNumber || {};
    const getGiftCardNumberError = state => getGiftCardNumber(state).error || '';
    const getErrorText = (state, type) => getErrors(state)[type] || '';
    const getCardsWithError = state => getGiftCard(state).cardsWithError || [];
    const getCardHasError = (state, cardNumber) => getCardsWithError(state).includes(cardNumber);
    const getValidationParams = state => getGiftCard(state).validationParams || {};
    const getGiftCardCodeToBeDeleted = state => getGiftCard(state).giftCardCodeToBeDeleted || '';
    const getGiftCardType = state => getGiftCard(state).cardType;

    return {
        ...dynaForms.getSelectors(storeName),
        getGiftCard,
        getErrors,
        getGiftCardNumber,
        getGiftCardData,
        getCardInfo,
        getGiftCards,
        getIsPayment,
        getIsVoucher,
        getIsBalanceCheck,
        getScrollToError,
        getErrorText,
        getGiftCardNumberError,
        getCardsWithError,
        getCardHasError,
        getValidationParams,
        getGiftCardCodeToBeDeleted,
        getGiftCardType,
        getCouponValidation,
        getValidationPattern,
        getCouponErrorText,
    };
};

export default getSelectors;
